import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ChevronArrowLeftIcon } from '../../../../assets/icons/ChevronArrowLeftIcon'
import { ChevronArrowRightIcon } from '../../../../assets/icons/ChevronArrowRightIcon'
import './DatePickerCalendar.scss'
import { getMergedClassNames } from '../../../../utils/HTMLutils'
import { dateToString, stringToDate } from '../../../../utils/ParsingUtils'
import { CSSTransition } from 'react-transition-group'
const rootClassName = 'component-date-picker-calendar'

function DatePickerCalendar(props) {
  const [today] = useState(new Date())
  const [month, setMonth] = useState(today.getMonth())
  const [year, setYear] = useState(today.getFullYear())
  useEffect(() => {
    if (props.value) {
      const d = stringToDate(props.value)
      setMonth(d.getMonth())
      setYear(d.getFullYear())
    } else {
      setMonth(today.getMonth())
      setYear(today.getFullYear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value])

  const getDaysInMonth = (mes, ano) => {
    let arr = new Array(31)
      .fill('')
      .map((v, i) => new Date(ano, mes, i + 1))
      .filter((v) => v.getMonth() === mes)

    if (arr[0].getDay() > 0) {
      let aux = new Date(arr[0].getTime() - 24 * 60 * 60 * 1000)
      while (true) {
        arr = [aux, ...arr]
        if (aux.getDay() === 0) break
        aux = new Date(aux.getTime() - 24 * 60 * 60 * 1000)
      }
    }

    if (arr[arr.length - 1].getDay() < 6) {
      let aux = new Date(arr[arr.length - 1].getTime() + 24 * 60 * 60 * 1000)
      while (true) {
        arr = [...arr, aux]
        if (aux.getDay() === 6) break
        aux = new Date(aux.getTime() + 24 * 60 * 60 * 1000)
      }
    }
    return arr
  }

  const [monthPage, setMonthPage] = useState(false)

  return (
    <div className={rootClassName}>
      <CSSTransition
        in={monthPage}
        classNames={`${rootClassName}-month-picker`}
        timeout={300}
        unmountOnExit
      >
        <div className={`${rootClassName}-month-picker`}>
          <div className='header'>
            <button
              className='prev'
              onClick={() => {
                setYear(year - 1)
              }}
            >
              <ChevronArrowLeftIcon />
            </button>
            <button className='month' disabled>
              {year}
            </button>
            <button
              className='next'
              onClick={() => {
                setYear(year + 1)
              }}
            >
              <ChevronArrowRightIcon />
            </button>
          </div>
          <div className={`${rootClassName}-months`}>
            {props.language.monthsAbrev.map((mes, index) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    setMonth(index)
                    setMonthPage(false)
                  }}
                  className={getMergedClassNames([
                    `${rootClassName}-month`,
                    index === month ? 'selected' : ''
                  ])}
                >
                  {mes}
                </button>
              )
            })}
          </div>
        </div>
      </CSSTransition>
      <CSSTransition
        in={!monthPage}
        timeout={300}
        classNames={`${rootClassName}-bottom-page`}
      >
        <div className={`${rootClassName}-first-page`}>
          <div className='header'>
            <button
              className='prev'
              onClick={() => {
                if (month === 0) {
                  setYear(year - 1)
                  setMonth(11)
                } else {
                  setMonth(month - 1)
                }
              }}
            >
              <ChevronArrowLeftIcon />
            </button>
            <button
              className='month'
              onClick={() => setMonthPage(!monthPage)}
            >{`${props.language.months[month]} / ${year}`}</button>
            <button
              className='next'
              onClick={() => {
                if (month === 11) {
                  setYear(year + 1)
                  setMonth(0)
                } else {
                  setMonth(month + 1)
                }
              }}
            >
              <ChevronArrowRightIcon />
            </button>
          </div>
          <div className='week-days'>
            {props.language && props.language.daysOfWeek
              ? props.language.daysOfWeek.map((day, index) => {
                  return (
                    <div key={index} className='label'>
                      {day}
                    </div>
                  )
                })
              : undefined}
          </div>
          <div className='days'>
            {getDaysInMonth(month, year).map((day, index) => {
              return (
                <button
                  onClick={() => {
                    if (typeof props.onChange === 'function') {
                      props.onChange(dateToString(day))
                    }
                  }}
                  key={index}
                  className={getMergedClassNames([
                    'day',
                    day.getFullYear() === today.getFullYear() &&
                    day.getMonth() === today.getMonth() &&
                    day.getDate() === today.getDate()
                      ? 'today'
                      : '',
                    props.value &&
                    day.getFullYear() ===
                      stringToDate(props.value).getFullYear() &&
                    day.getMonth() === stringToDate(props.value).getMonth() &&
                    day.getDate() === stringToDate(props.value).getDate()
                      ? 'selected'
                      : ''
                  ])}
                  disabled={day.getMonth() !== month}
                >
                  {day.getDate()}
                </button>
              )
            })}
          </div>
        </div>
      </CSSTransition>
    </div>
  )
}
DatePickerCalendar.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  language: PropTypes.shape({
    daysOfWeek: PropTypes.arrayOf(PropTypes.string),
    months: PropTypes.arrayOf(PropTypes.string),
    monthsAbrev: PropTypes.arrayOf(PropTypes.string)
  })
}

export default memo(DatePickerCalendar)
